<template>
  <div class="olympicMusicShowRecord" v-if="detail">
    <div class="card_box">
      <div class="cell_item">
        <div class="header">
          <span class="text1">{{detail.competition ? detail.competition.name : ''}}</span>
          <span class="text2">{{detail.statusText}}</span>
        </div>
        <div class="main">
          <div class="left">
            <div class="text">报名单号： {{detail.id}}</div>
            <div class="text" v-if="detail.isSingle">参赛人： {{detail.contestants.length > 0 ? detail.contestants[0].realName : ''}}</div>
            <div class="text" v-else>团队名称： {{detail.teamName}}</div>
            <div class="text">参赛类型： {{detail.entryType ? detail.entryType.name : ''}}</div>
            <div class="text">组别： {{detail.entryGroup ? detail.entryGroup.name : ''}}</div>
            <div class="text">报名时间： {{detail.createTime}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="middle_box">
      <span>已获取成绩：{{detail.statusText}}</span>
    </div>

    <div class="middle_box">
      <span>后续赛事安排通知：等待比赛开始</span>
    </div>

    <div class="intro_box">
      <div class="title">报名表信息</div>
      <div class="text" v-if="detail.isSingle">参赛人： {{detail.contestants.length > 0 ? detail.contestants[0].realName : ''}}</div>
      <div class="text" v-if="detail.isSingle">性别： {{detail.contestants.length > 0 ? detail.contestants[0].genderText : ''}}</div>
      <div class="text" v-if="detail.isSingle">民族： {{detail.contestants.length > 0 ? detail.contestants[0].nation : ''}}</div>
      <div class="text" v-if="detail.isSingle">出生年份： {{detail.contestants.length > 0 ? detail.contestants[0].birthForYear : ''}}</div>
      <div class="text" v-if="!detail.isSingle">团队名称： {{detail.teamName}}</div>
      <div class="text" v-if="!detail.isSingle">指导老师： {{detail.teacherName}}</div>
      <div class="text" v-if="detail.isSingle">证件类型： {{detail.certificateType == 1 ? '身份证' : '护照及港澳通行证'}}</div>
      <div class="text" v-if="detail.isSingle">证件号码： {{detail.contestants.length > 0 ? detail.contestants[0].certificateCode : ''}}</div>
      <div class="text" v-if="!detail.isSingle">指导老师电话： {{detail.teacherPhone}}</div>
      <div class="text">指导机构名称： {{detail.agency}}</div>
      <div class="text" v-if="!detail.isSingle">指导机构所在区域： {{detail.regionText}}</div>
      <div class="text" v-if="!detail.isSingle">证件邮寄地址： {{detail.postAddress}}</div>
      <div class="text" v-if="detail.isSingle">所在学校地区： {{detail.regionText}}</div>
      <div class="text" v-if="detail.isSingle">就读学校名称： {{detail.contestants.length > 0 ? detail.contestants[0].currentSchool : ''}}</div>
      <div class="text" v-if="detail.isSingle">就读学校地址： {{detail.contestants.length > 0 ? detail.contestants[0].schoolAddress : ''}}</div>
      <div class="text" v-if="detail.isSingle">家长姓名： {{detail.contestants.length > 0 ? detail.contestants[0].parentName : ''}}</div>
      <div class="text" v-if="detail.isSingle">联系电话： {{detail.contestants.length > 0 ? detail.contestants[0].mobile : ''}}</div>
      <div class="text">参赛类型： {{detail.entryType ? detail.entryType.name : ''}}</div>
      <div class="text">参赛方式： {{detail.competitionModeText}}</div>
      <div class="text">参赛组别： {{detail.entryGroup ? detail.entryGroup.name : ''}}</div>
      <div class="text">参赛曲目： {{detail.repertoire}}</div>
      <div class="text" v-if="detail.professional && detail.professional.name !== '声乐'">使用乐器： {{detail.professional.name}}</div>
      <div class="text text_box" v-if="!detail.isSingle">
        <span class="name_text">报名成员： </span>
        <div class="value_box">
          <span class="text"
            v-for="item in detail.contestants"
            :key="item.id"
          >{{item.realName}} {{item.mobile}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiGetsignuprecord } from '@/api/olympicMusicShow.js'
import { Toast } from 'vant'

export default {
  name: 'olympicMusicShowRecord',
  data() {
    return {
      detail: null
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/olympicMusicShow/singleRegister' || to.path === '/olympicMusicShow/multiRegister') {
      this.$store.commit('olympicMusicShow/resetSingleForm')
      this.$store.commit('olympicMusicShow/resetMultiForm')
      next({ path: '/olympicMusicShow/home' })
    } else {
      next()
    }
  },
  mounted() {
    document.title = '赛程详情'

    this.getDetail()
  },
  methods: {
    getDetail() {
      let params = {
        RecordId: this.$route.query.id
      }

      ApiGetsignuprecord(params).then(res => {
        if (res.code === 200) {
          this.detail = res.data
        } else {
          Toast(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/flexable.scss';

.olympicMusicShowRecord {
  width: 100%;
  min-height: 100vh;
  background-color: #F5F5F9;
  .card_box {
    margin-bottom: px2rem(20);
    padding-top: px2rem(20);
    .cell_item {
      margin-bottom: px2rem(20);
      width: 100%;
      padding: px2rem(30) px2rem(40);
      border-radius: px2rem(8);
      background-color: #fff;
      box-sizing: border-box;
      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: px2rem(40);
        line-height: 1;
        font-size: px2rem(32);
        font-weight: bold;
        color: #1F1F1F;
      }
      .main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          .text {
            display: block;
            margin-bottom: px2rem(27);
            text-align: left;
            line-height: 1;
            font-size: px2rem(30);
            font-weight: 500;
            color: #585858;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        .right {
          display: flex;
          align-items: center;
          .text {
            margin-right: px2rem(6);
            line-height: 1;
            font-size: px2rem(30);
            font-weight: 500;
            color: #585858;
          }
        }
      }
    }
  }

  .middle_box {
    margin-bottom: px2rem(20);
    width: 100%;
    height: px2rem(140);
    text-align: left;
    line-height: px2rem(140);
    padding-left: px2rem(40);
    font-size: px2rem(30);
    font-weight: 500;
    color: #585858;
    background-color: #fff;
    box-sizing: border-box;
  }

  .intro_box {
    text-align: left;
    width: 100%;
    padding-top: px2rem(16);
    padding-left: px2rem(40);
    padding-bottom: px2rem(50);
    box-sizing: border-box;
    .title {
      margin-bottom: px2rem(40);
      line-height: 1;
      font-size: px2rem(32);
      font-weight: bold;
      color: #1F1F1F;
    }
    .text {
      margin-bottom: px2rem(30);
      line-height: 1;
      font-size: px2rem(30);
      font-weight: 500;
      color: #585858;
    }

    .text_box {
      display: flex;
      .name_text {
        white-space: nowrap;
      }
    }
    .value_box {
      padding-right: px2rem(20);
      box-sizing: border-box;
      .text {
        display: block;
      }
    }
  }
}
</style>